/* Notify-me enhancement — added 21 Oct 2026.
   The notify button itself is Klaviyo's app embed (#klaviyo-bis-button-container),
   injected into .product-form__buttons. This file only does the theme-side work:
     1. hides the dead "Sold out" button and Shop Pay on sold-out products
     2. re-enables the size buttons so a shopper can say WHICH size they want
     3. restyles Klaviyo's notify button to match the site (Geist, 45px, outlined)
   Revert by deleting the bis-enhance-loader render line in layout/theme.liquid.

   22 Oct 2026 fix: sold-out is now read from the selected variant's real stock,
   not from whether Add To Cart is disabled. Dawn briefly disables Add To Cart
   while it loads a newly picked size, so the old check caught that moment,
   flagged the page sold out, and hid Add To Cart until a refresh. */
(function () {
  'use strict';

  var CSS = [
    /* kill the dead buttons, keep Klaviyo's notify button */
    '.bis-sold-out .product-form__submit{display:none!important}',
    '.bis-sold-out .shopify-payment-button{display:none!important}',
    '.bis-sold-out shopify-payment-terms{display:none!important}',
    '.bis-sold-out #klaviyo-bis-button-container{margin-top:0!important}',
    /* a freed size reads as choosable, not as stock */
    '.bis-sold-out variant-radios input[data-bis-freed]+label{opacity:1;cursor:pointer}',
    '.bis-sold-out variant-radios input[data-bis-freed]:checked+label{outline:1px solid currentColor;outline-offset:2px}',
    /* notify button: match Add To Cart size and site font, outlined so it reads as "not buy" */
    '#klaviyo-bis-button-container button{font-family:var(--font-body-family,Geist,sans-serif)!important;font-size:15px!important;font-weight:400!important;letter-spacing:1px!important;text-transform:none!important;height:45px!important;min-height:45px!important;padding:9px 30px 11px!important;border-radius:0!important;background:#fff!important;color:#000!important;border:0!important;box-shadow:0 0 0 1px #000 inset!important;width:100%!important;box-sizing:border-box!important;margin:0!important;transition:background .15s,color .15s}',
    '#klaviyo-bis-button-container button:hover{background:#000!important;color:#fff!important}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('bis-enhance-css')) return;
    var s = document.createElement('style');
    s.id = 'bis-enhance-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* The variant list Dawn embeds in the size picker. */
  function variants() {
    var el = document.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Which variant is picked right now. Dawn updates the form's hidden id
     input the moment a size is clicked, before it reloads the button. */
  function currentId() {
    var input = document.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function soldOut() {
    var list = variants();
    var id = currentId();
    if (list && id) {
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].id) === id) return !list[i].available;
      }
    }
    /* fallback only if the variant data can't be read */
    var submit = document.querySelector('.product-form__submit');
    return !!(submit && submit.hasAttribute('disabled') && !submit.classList.contains('loading'));
  }

  /* Shopify disables every size radio when nothing is in stock, so the shopper
     cannot tell us which size to notify them about. Free them — the add-to-cart
     button is hidden, so nothing can reach the cart. */
  function freeSizes() {
    var n = 0;
    document.querySelectorAll('variant-radios input[type="radio"][disabled]').forEach(function (i) {
      i.removeAttribute('disabled');
      i.setAttribute('data-bis-freed', '1');
      n++;
    });
    return n;
  }

  function run() {
    if (!document.querySelector('variant-radios, variant-selects')) return;
    injectCSS();
    if (soldOut()) {
      document.body.classList.add('bis-sold-out');
      freeSizes();
    } else {
      document.body.classList.remove('bis-sold-out');
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-radios, variant-selects')) {
      setTimeout(run, 80);
      setTimeout(run, 800); /* re-check after Dawn finishes reloading the button */
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();
